export default "__VITE_ASSET__8acac648__"